import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PhotoCameraRounded, DocumentScannerRounded, BoltRounded } from '@mui/icons-material';

interface Feature {
  icon: React.ReactNode;
  iconBg: string;
  iconColor: string;
  text: string;
}

const FEATURES: Feature[] = [
  {
    icon: <DocumentScannerRounded fontSize="inherit" />,
    iconBg: '#ede7f6',
    iconColor: '#3F51B5',
    text: 'Scan container, chassis & seal numbers with your camera',
  },
  {
    icon: <PhotoCameraRounded fontSize="inherit" />,
    iconBg: '#e3f2fd',
    iconColor: '#0D96F6',
    text: 'Capture equipment condition photos at the gate',
  },
  {
    icon: <BoltRounded fontSize="inherit" />,
    iconBg: '#e6f4ea',
    iconColor: '#01875F',
    text: 'Check trucks in & out and manage yard inventory',
  },
];

const FeatureIconBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'iconBg' && prop !== 'iconColor',
})<{ iconBg: string; iconColor: string }>(({ iconBg, iconColor }) => ({
  width: 32,
  height: 32,
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  fontSize: '1.15rem',
  backgroundColor: iconBg,
  color: iconColor,
}));

const MobileAppFeatureList = () => (
  <Stack spacing={1.75} justifyContent="center" sx={{ minWidth: 0 }}>
    <Typography
      sx={{ fontSize: '0.8929rem', fontWeight: 700, color: '#1a2636', letterSpacing: '0.2px' }}
    >
      Everything you need to run the gate:
    </Typography>
    {FEATURES.map((feature) => (
      <Stack key={feature.text} direction="row" spacing={1.5} alignItems="center">
        <FeatureIconBox iconBg={feature.iconBg} iconColor={feature.iconColor} aria-hidden="true">
          {feature.icon}
        </FeatureIconBox>
        <Typography sx={{ fontSize: '0.9643rem', fontWeight: 500, color: '#42546b' }}>
          {feature.text}
        </Typography>
      </Stack>
    ))}
  </Stack>
);

export default MobileAppFeatureList;
